/**
 * The 'GO' flash at the moment a round's clock starts.
 *
 * Mirrors Blockari's (`screens/start-cue.ts`, b1a4de6), where the 3-2-1 can be
 * switched off and a game then began with nothing to say the clock had. 21 Wild
 * has no countdown, so every round that starts fresh gets the cue; a resumed
 * round picks up where it was, and the walkthrough is a scripted demo, not a
 * round the player is starting. Presentation only: nothing here touches the
 * engine, the input log or the replay.
 */

import { DEMO_DECK } from '@/ui/guideScript';

/** How long the flash lives. Blockari's `GO_CUE_MS`; the CSS animation runs the same 0.9s. */
export const GO_FLASH_MS = 900;

export interface GoFlashRound {
  /** Picking a round back up (from pause, or a server round already in progress) rather than starting it. */
  resumed?: boolean;
  /** The first-run walkthrough — a demo played on the real board, not the player's round. */
  scripted?: boolean;
}

/** Whether the round that is starting gets the flash: a fresh, real round only. */
export function showGoFlash(round: GoFlashRound = {}): boolean {
  return !round.resumed && !round.scripted;
}

/**
 * The walkthrough is the one round dealt from a stacked deck, and its deck is
 * dealt unshuffled, so the stock it opens with is that deck exactly.
 */
export function isDemoStock(stock: readonly string[]): boolean {
  return stock.length === DEMO_DECK.length && stock.every((card, i) => card === DEMO_DECK[i]);
}
